import swaggerClient from "../remote-client";
import Utils from "../Utils";

export default class LoginServiceImpl {
  fetchUserPerm(officeId) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacility.getPermissionOfficeWithId(
            {
              id: officeId
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(result => {
        return result.body.listPermission;
      })
      .catch(reason => {
        return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
      });
  }

  // CHECK USERNAME
  checkUsername(username) {
    return swaggerClient.userSwaggerClient
      .then(
        client => {
          return client.apis.UserHealthFacility.getHfUserUsernameWithUsername(
            {
              username
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        result => {
          return result.body;
        },
        reason => {
          return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
        }
      );
  }

  // ACTIVATE USER
  activateUser(token, username, password) {
    return swaggerClient.userSwaggerClient
      .then(
        client => {
          return client.apis.UserHealthFacility.postHfUser(
            {},
            swaggerClient.buildRequest({
              token,
              username,
              password,
              portal: "HF"
            }),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        result => {
          return result.body;
        },
        reason => {
          return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
        }
      );
  }

  // GET USER INFO
  getUserInfo() {
    return swaggerClient.userSwaggerClient
      .then(
        client => {
          return client.apis.UserHealthFacility.getHfUserInfo(
            {},
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        result => {
          return result.body.user;
        },
        reason => {
          return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
        }
      );
  }
}
